module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Plus-0be418362e62060b9a97c017edce4a56.svg";